module.exports = __webpack_public_path__ + "static/media/small-game@2x.23d24321.jpg";